/**
 * @module support/ingenico
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// tslint:disable:max-file-line-count

import { Injectable } from '@angular/core';
import { CreditCardIngenicoResponse } from '@support/ingenico/interfaces/ingenico.interface';
import { of as observableOf, Subject, Observable } from 'rxjs';
import { LoggerService } from '@core/logger/services/logger.service';

/**
 * Ingenico Service, Wrappers around the Ingenico logic
 * @access public
 */
@Injectable()
export class IngenicoService {
  //export class IngenicoService extends HasBase {

  private computerName: Subject<string>;
  public cardInserted: Subject<string>;
  constructor(private logger: LoggerService) {
    //super();
    //this.computerName = new Subject<string>();
    //this.cardInserted = new Subject<string>();
    //this.initIngenicoEvents();
  }

  /**
   * Opens Cash Drawer
   * @returns void
   */
  public openCashDrawer(): void {
    /*
    this.logData({request: null, response: {method: 'openCashDrawer'}});
    this.ingenico.openCashDrawer();
    */
  }

  /**
   * Display card swipe screen in ingenico for Transaction
   * @param {string} langPref
   * @param {string} ccFormName
   * @param {boolean} isVesta
   * @param {string} amount
   * @param {boolean} isReturn
   * @param {string} aid
   * @param {boolean} isResumeTransaction
   * * @return {CreditCardIngenicoResponse} Observable
   */
  public captureCreditCardFD(
    langPref: string,
    ccFormName?: string,
    isVesta?: boolean,
    amount?: string,
    isReturn: boolean = false,
    aid?: string,
    isResumeTransaction: boolean = false,
    isEmvEnabled?: boolean,
    txnNumber?: string
  ): Observable<CreditCardIngenicoResponse> {
    const subject = new Subject<Object>();
    /*
    const loggerReq = {
      method: 'captureCreditCardFD',
      langPref: langPref,
      ccFormName: ccFormName,
      isVesta: isVesta,
      amount: amount,
      isReturn: isReturn,
      aid: aid,
      isResumeTransaction: isResumeTransaction,
      isEmvEnabled: isEmvEnabled,
      txnNumber: txnNumber
    };
    const FIXED_TWO_DECIMAL = 2;
    let isCardInserted = false;
    if (!isResumeTransaction) {
      if (isEmvEnabled) {
        amount = amount ? amount.replace(/\`|\$|,|\s/g, '') : '0';
        amount = Number(amount).toFixed(FIXED_TWO_DECIMAL).toString();
        console.log('ingenico: captureEmvCardData');
        this.ingenico.captureEmvCardData(langPref, '', '', '', amount, true, isReturn,
                                         true, txnNumber);
        this.logData({request: loggerReq, response: {method: 'captureEmvCardData'}});
        this.ingenico.smartCardInserted = () => {
          console.log('ingenico: smartCardInserted');
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.CARD_INSERTED}});
          this.cardInserted.next(SHARED_PAYMENT.CARD_INSERTED);
          isCardInserted = true;
        };
        this.ingenico.smartCardRemoved = () => {
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.CARD_REMOVED}});
          console.log('ingenico: smartCardRemoved');
          isCardInserted = false;
          this.cardInserted.next(SHARED_PAYMENT.CARD_REMOVED);
          this.cardInserted.complete();
        };
        this.ingenico.smartCardRemovedEarly = () => {
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.CARD_REMOVED_EARLY}});
          console.log('ingenico: smartCardRemovedEarly');
          this.cardInserted.next(SHARED_PAYMENT.CARD_REMOVED_EARLY);
        };
        this.ingenico.smartCardReadFailure = () => {
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.TECHNICAL_FALLBACK}});
          this.cardInserted.next(SHARED_PAYMENT.TECHNICAL_FALLBACK);
        };
        this.ingenico.emptyCandidateListHandler = () => {
          this.cardInserted.next(SHARED_PAYMENT.TECHNICAL_FALLBACK);
        };
        this.ingenico.userTimeout = () => {
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.PIN_ENTRY_TIME_OUT}});
          console.log('ingenico: pinEntryRetryExhausted');
          this.cardInserted.next(SHARED_PAYMENT.PIN_ENTRY_TIME_OUT);
          subject.complete();
        };
        this.ingenico.pinEntryRetryExhausted = () => {
          this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.PIN_ENTRY_LIMIT_EXCEEDED}});
          console.log('ingenico: pinEntryRetryExhausted');
          this.cardInserted.next(SHARED_PAYMENT.PIN_ENTRY_LIMIT_EXCEEDED);
          subject.complete();
        };
      } else {
        this.logData({request: loggerReq, response: {method: 'captureCreditCardFD'}});
        console.log('ingenico: captureCreditCardFD');
        this.ingenico.captureCreditCardFD(langPref, ccFormName, isVesta, txnNumber);


      }
    } else {
      console.log('ingenico: resumeEmvTransaction');
      amount = amount ? amount.replace(/\`|\$|,|\s/g, '') : '0';
      amount = Number(amount).toFixed(FIXED_TWO_DECIMAL).toString();
      this.logData({request: loggerReq, response: {method: 'resumeEmvTransaction'}});
      this.ingenico.resumeEmvTransaction(langPref, aid, '', '', amount, amount, txnNumber);
    }
    this.ingenico.onMSRDataReadyHandlerFD = (creditCardData: CreditCardIngenicoResponse) => {
      console.log('ingenico: onMSRDataReadyHandlerFD', creditCardData);
      creditCardData.isCardInserted = isCardInserted;
      this.logData({request: loggerReq, response: {method: 'onMSRDataReadyHandlerFD',
                                                   data: {creditCardData: creditCardData}}});
      subject.next(creditCardData);
      subject.complete();
    };
    this.ingenico.onMSRDataReadyHandler = (creditCardData: CreditCardIngenicoResponse) => {
      creditCardData.isCardInserted = isCardInserted;
      this.logData({request: loggerReq, response: {method: 'onMSRDataReadyHandler',
                                                   data: {creditCardData: creditCardData}}});
      subject.next(creditCardData);
      subject.complete();
    };
    this.ingenico.onAcceptHandler = (creditCardData: CreditCardIngenicoResponse) => {
      this.logData({request: loggerReq, response: {method: 'onAcceptHandler',
                                                   data: {creditCardData: creditCardData}}});
      console.log('ingenico: onAcceptHandler', creditCardData);
      creditCardData.isCardInserted = isCardInserted;
      subject.next(creditCardData);
      subject.complete();
    };
    this.ingenico.onEMVDataReadyHandler = (creditCardData: CreditCardIngenicoResponse) => {
      this.logData({request: loggerReq, response: {method: 'onEMVDataReadyHandler',
                                                   data: {creditCardData: creditCardData}}});
      console.log('ingenico: onEMVDataReadyHandler');
      creditCardData.isCardInserted = isCardInserted;
      subject.next(creditCardData);
      subject.complete();
    };
    this.ingenico.userDeclinedAmount = () => {
      console.log('ingenico: userDeclinedAmount');
      this.logData({request: loggerReq, response: {method: 'userDeclinedAmount'}});
      subject.error('userDeclinedAmount');
      subject.complete();
    };
    this.ingenico.pinEntryRetryExhausted = () => {
      console.log('ingenico: pinEntryRetryExhausted');
      this.logData({request: loggerReq, response: {method: 'pinEntryRetryExhausted'}});
      subject.error('pinEntryRetryExhausted');
      subject.complete();
    };
    this.ingenico.chipCardDeclined = () => {
      console.log('ingenico: chipCardDeclined');
      this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.CARD_DECLINED}});
      subject.error(SHARED_PAYMENT.CARD_DECLINED);
      subject.complete();
    };
    this.ingenico.isBlockedCardOrAid = () => {
      console.log('ingenico: isBlockedCardOrAid');
      this.logData({request: loggerReq, response: {method: 'isBlockedCardOrAid'}});
      subject.error('isBlockedCardOrAid');
      subject.complete();
    };
    this.ingenico.onCancelHandler = () => {
      console.log('ingenico: onCancelHandler');
      this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.TRANSACTION_CANCELLED}});
      subject.error(SHARED_PAYMENT.TRANSACTION_CANCELLED);
      subject.complete();
    };

    this.ingenico.onErrorHandler = (message: string) => {
      console.log('ingenico: pinEntryRetryExhausted');
      this.logData({request: loggerReq, response: {method: 'onCancelHandler',
                                                   data: {message: message}}});
      subject.error(message);
      subject.complete();
    };
    this.ingenico.isBlockedCardOrAid = () => {
      console.log('ingenico: isBlockedCardOrAid');
      this.logData({request: loggerReq, response: {method: SHARED_PAYMENT.BLOCKED_CARD_BLOCKED_AID}});
      subject.error(SHARED_PAYMENT.BLOCKED_CARD_BLOCKED_AID);
      subject.complete();
    };
    this.ingenico.cardRefundData = (creditCardData: CreditCardIngenicoResponse) => {
      this.logData({request: loggerReq, response: {method: 'cardRefundData',
                                                   data: {creditCardData: creditCardData}}});
      console.log('ingenico: cardRefundData');
      creditCardData.isCardInserted = isCardInserted;
      subject.next(creditCardData);
    };
  */
    return subject.asObservable();
  }

  /**
   * Display validate amount form screen in ingenico for Transaction
   * @param {string} langPref
   * @param {string} amount
   * @return {CreditCardIngenicoResponse} Observable
   */
  public verifyAmount(langPref: string, amount: string): Observable<string> {
    const subject = new Subject<string>();
    /*
    const loggerReq = {
      method: 'verifyAmount',
      langPref: langPref,
      amount: amount
    };
    console.log('ingenico: verifyAmount', langPref, amount);
    this.logData({request: loggerReq, response: {method: 'verifyAmount'}});
    this.ingenico.verifyAmount(langPref, amount);
    this.ingenico.onAcceptHandler = (userInputData: string) => {
      console.log('ingenico: onAcceptHandler', userInputData);
      this.logData({request: loggerReq, response: {method: 'onAcceptHandler',
                                                   data: {userInputData: userInputData}}});
      subject.next(userInputData);
      subject.complete();
    };

    this.ingenico.onCancelHandler = () => {
      console.log('ingenico: onCancelHandler');
      this.logData({request: loggerReq, response: {method: 'onCancelHandler'}});
      subject.next('');
      subject.complete();
    };
  */
    return subject.asObservable();
  }

  /**
   * Display terms and conditions on ingenico screen
   * @param {string} langPref
   * @param {string} textString
   */
  public acceptTermsAndConditionsForm(langPref: string): Observable<string> {
    /**
    return new Observable((observer: Subscriber<string>) => {
      this.ingenico.onErrorMessageHandler = (error: string) => {
        this.logData({request: langPref, response: {method: 'onErrorMessageHandler',
                                                    data: {error: error}}});
        observer.error(error);
        observer.complete();
      };
      this.ingenico.onAcceptHandler = (userInputData: string) => {
        this.logData({request: langPref, response: {method: 'onAcceptHandler',
                                                    data: {userInputData: userInputData}}});
        console.log('ingenico: onAcceptHandler', userInputData);
        observer.next(userInputData);
        observer.complete();
      };
      this.ingenico.onCancelHandler = () => {
        this.logData({request: langPref, response: {method: 'onCancelHandler'}});
        console.log('ingenico: onCancelHandler');
        observer.next();
        observer.complete();
      };
      this.ingenico.onErrorHandler  = (error: string) => {
        this.logData({request: langPref, response: {method: 'onErrorHandler',
                                                    data: {error: error}}});
        observer.error(error);
        observer.complete();
      };
      // As per prepaid, we need to send 19 from rebellion
      this.logData({request: langPref, response: {method: 'displayText'}});
      this.ingenico.displayText(langPref, '19', false, '', '', '', '', '');
      return observer;
    });
    */
    return observableOf(null);
  }

  /**
   * Display process as credit form screen in ingenico for Transaction
   * @param {string} langPref
   * @param {string} amount
   * @return {CreditCardIngenicoResponse} Observable
   */
  public processCreditCard(
    langPref: string,
    amount: number | string,
    txnNumber?: string
  ): Observable<string> {
    const subject = new Subject<string>();
    /*
    const loggerReq = {
      method: 'processCreditCard',
      langPref: langPref,
      amount: amount,
      txnNumber: txnNumber
    };
    this.logData({request: loggerReq, response: {method: 'processCreditCard'}});
    console.log('ingenico: processCreditCard');
    this.ingenico.processCreditCard(langPref, amount, txnNumber);
    this.ingenico.onAcceptHandler = (userInputData: string) => {
      this.logData({request: langPref, response: {method: 'onAcceptHandler',
                                                  data: {userInputData: userInputData}}});
      console.log('ingenico: onAcceptHandler', userInputData);
      subject.next(userInputData);
      subject.complete();
    };
    this.ingenico.onCancelHandler = () => {
      this.logData({request: loggerReq, response: {method: 'onCancelHandler'}});
      console.log('ingenico: onCancelHandler');
      subject.next('');
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  /**
   * Display capture pin in ingenico for Transaction
   * @param {string} langPref
   * @param {String} accountNumber
   * @param {string} prompt
   * @param {boolean} useAsCredit
   * @return {Observable<string>}
   */
  public capturePin(
    langPref: string,
    accountNumber: String,
    prompt: string,
    useAsCredit: boolean,
    txnNumber?: string
  ): Observable<string> {
    const subject = new Subject<string>();
    /*
    const loggerReq = {
      method: 'capturePin',
      langPref: langPref,
      accountNumber: accountNumber,
      prompt: prompt,
      useAsCredit: useAsCredit,
      txnNumber: txnNumber
    };
    this.logData({request: loggerReq, response: {method: 'capturePin'}});
    console.log('ingenico: capturePin');
    this.ingenico.capturePin(langPref, accountNumber, prompt, useAsCredit, txnNumber);
    this.ingenico.onDebitPinReadyHandler = (userInputData: string) => {
      this.logData({request: loggerReq, response: {method: 'onDebitPinReadyHandler',
                                                   data: {userInputData: userInputData}}});
      console.log('ingenico: onDebitPinReadyHandler');
      subject.next(userInputData);
      subject.complete();
    };
    this.ingenico.onCancelHandler = () => {
      this.logData({request: loggerReq, response: {method: 'onCancelHandler'}});
      console.log('ingenico: onCancelHandler');
      subject.next('');
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  /**
   * Display declined informaiton in ingenico for Transaction
   * @param {string} langPref
   * @param {string} informationType
   */
  public displayDeclinedForm(langPref: string, informationType: string): void {
    /*
    const loggerReq = {
      method: 'displayDeclinedForm',
      langPref: langPref,
      informationType: informationType
    };
    this.logData({request: loggerReq, response: {method: 'displayInformationForm'}});
    console.log('ingenico: displayInformationForm');
    this.ingenico.displayInformationForm(langPref, informationType);
    */
  }

  /**
   * Display message to customer sign for Transaction
   * @param {string} langPref
   * @param {string} sigType
   * @param {string} totalAmount
   * @return {Observable<Object>}
   */
  public captureSignature(
    langPref: string,
    sigType: string,
    totalAmount: string
  ): Observable<object> {
    const subject = new Subject<Object>();
    /*
    const loggerReq = {
      method: 'captureSignature',
      langPref: langPref,
      sigType: sigType,
      totalAmount: totalAmount
    };
    this.logData({request: loggerReq, response: {method: 'captureSignature'}});
    console.log('ingenico: captureSignature');
    this.ingenico.captureSignature(langPref, sigType.toLocaleUpperCase(), totalAmount);
    this.ingenico.onSignatureDataReadyHandler = (signData: string, htmlSignBlock: string, signBlock: string) => {
      const data = {
        signData: signData,
        htmlSignBlock: htmlSignBlock,
        signBlock: signBlock
      };
      this.logData({request: loggerReq, response: {method: 'onSignatureDataReadyHandler', data: data}});
      console.log('ingenico: onSignatureDataReadyHandler');
      subject.next([signData, htmlSignBlock, signBlock]);
      subject.complete();
    };
    this.ingenico.onAcceptHandler = (userInputData: string) => {
      this.logData({request: loggerReq, response: {method: 'onAcceptHandler', data: {userInputData: userInputData}}});
      console.log('ingenico: onAcceptHandler');
      subject.next(userInputData);
      subject.complete();
    };
    this.ingenico.onCancelHandler = () => {
      this.logData({request: loggerReq, response: {method: 'onCancelHandler'}});
      console.log('ingenico: onCancelHandler');
      subject.next('');
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  /**
   * Display message to process payment
   * @param {string} langPref
   * @param {string} authAmount
   * @param {number} remainAmount
   * @return {Observable<Object>}
   */
  public displayPartialAuthForm(
    langPref: string,
    authAmount: number,
    remainAmount: number
  ): Observable<string> {
    const subject = new Subject<string>();
    /*
    const fractionDigits = 2;
    const loggerReq = {
      method: 'displayPartialAuthForm',
      langPref: langPref,
      authAmount: authAmount,
      remainAmount: remainAmount
    };
    console.log('ingenico: displayPartialAuthForm');
    this.ingenico.displayPartialAuthForm(langPref, authAmount.toFixed(fractionDigits),
                                         remainAmount.toFixed(fractionDigits));
    this.ingenico.onAcceptHandler = (response: string) => {
      this.logData({request: loggerReq, response: {method: 'onAcceptHandler', data: response}});
      console.log('ingenico: onAcceptHandler');
      subject.next(response);
      subject.complete();
    };
    this.ingenico.onCancelHandler = () => {
      this.logData({request: loggerReq, response: {method: 'onCancelHandler'}});
      console.log('ingenico: onCancelHandler');
      subject.next('');
      subject.complete();
    };
    */
    return subject;
  }

  /**
   * Assign displayInformationForm
   * @returns void
   */
  public displayInformationForm(langPref: string, informationType: string): void {
    /*
    const loggerReq = {
      method: 'displayInformationForm',
      langPref: langPref,
      informationType: informationType
    };
    this.logData({request: loggerReq, response: {method: 'displayInformationForm'}});
    console.log('ingenico: displayInformationForm');
    this.ingenico.displayInformationForm(langPref, informationType);
    */
  }

  /**
   * Assign displayWelcome
   * @returns void
   */
  public displayWelcome(langPref: string): void {
    /*
    this.logData({request: langPref, response: {method: 'displayWelcome'}});
    console.log('ingenico: displayWelcome');
    this.ingenico.displayWelcome(langPref);
    */
  }

  /**
   * Assign displayThankYou
   * @returns void
   */
  public displayThankYou(langPref: string): void {
    /*
    this.logData({request: langPref, response: {method: 'displayThankYou'}});
    this.ingenico.displayThankYou(langPref);
    */
  }

  public softDeviceReset(softCode: string): void {
    /*
    this.logData({request: softCode, response: {method: 'softDeviceReset'}});
    this.ingenico.softDeviceReset(softCode);
    */
  }

  /**
   * Assign displayAds
   * @returns void
   */
  public displayAds(): void {
    /*
    this.logData({request: null, response: {method: 'displayAds'}});
    this.ingenico.displayAds();
    */
  }

  /**
   * Assign displayForm
   * @returns void
   */
  public displayForm(message: string): void {
    /*
    this.logData({request: message, response: {method: 'writeMessageToIngenico'}});
    this.ingenico.writeMessageToIngenico(message);
    */
  }

  /**
   * Obtain information from scanning Driver's license
   * @param {string} langPref
   * @return {Observable<Object>}
   */
  public captureDL(langPref: string): Observable<object> {
    const subject = new Subject<object>();
    /*
    this.ingenico.onDLDataReadyHandler = (dlData: object) => {
      this.logData({request: langPref, response: {method: 'onDLDataReadyHandler', data: {dlData: dlData}}});
      console.log('ingenico: onDLDataReadyHandler');
      subject.next(dlData);
      subject.complete();
    };
    this.ingenico.captureDL(langPref);
    */
    return subject.asObservable();
  }
  /**
   * Launchs Quick View
   * @returns void
   */
  // tslint
  public launchQuikView(
    ban: string,
    msisdn: string,
    channel: string,
    // tslint:disable-next-line:no-any
    ssoToken: any
  ): void {
    /*
    const loggerReq = {
      method: 'launchQuikView',
      ban: ban,
      msisdn: msisdn,
      channel: channel,
      ssoToken: ssoToken
    };
    this.logData({request: loggerReq, response: {method: 'launchQuikView'}});
    this.ingenico.launchQuikView(ban, msisdn, ssoToken, channel);
    */
  }

  /**
   * method to create listener for smart card removal event
   * @returns {Observable<string>}
   */
  public getCardInsertStatus(): Observable<string> {
    /*
    if (this.cardInserted && !this.cardInserted.closed) {
      this.cardInserted.complete();
    }
    this.cardInserted = new Subject<string>();
    return this.cardInserted.asObservable();
    */
    return new Subject<string>().asObservable();
  }

  public isChipEnabled(): Observable<boolean> {
    /*
    return this.getHasVersion()
      .pipe(flatMap((version: string) => {
        // validating HAS version and store is enabled for chip
        if (version >= INGENICO_CONSTANT.HAS_VERSION) {
          return this.getDeviceVersion();
        } else {
          return observableThrowError(false);
        }
      }), flatMap((deviceVersion: string) => {
        // validating Device version
        if (deviceVersion >= INGENICO_CONSTANT.DEVICE_VERSION) {
          return this.isEmvEnabled();
        } else {
          return observableThrowError(false);
        }
      }), map((isEmvEnabled: boolean) => {
        return isEmvEnabled;
      }), catchError(() => {
        return observableOf(false);
      }));
    */
    return new Subject<boolean>().asObservable();
  }

  /**
   * method to get id of USB connected cash drawer
   * @returns {Observable<string>}
   * For no cashdrawer, expected values are “error”, “notfound”
   * Valid value : alphanumeric (1-255) eg: “1”, “99”, 122” etc.
   */
  public getCashDrawerHID(): Observable<string> {
    /*
    const subject = new Subject<string>();
    this.logData({request: null, response: {method: 'getCashDrawerHID'}});
    this.ingenico.onCashDrawerHidHandler = (id: string) => {
      this.logData({request: null, response: {method: 'onCashDrawerHidHandler', data: {id: id}}});
      subject.next(id);
      subject.complete();
    };
    this.ingenico.getCashDrawerHID();
    return subject.asObservable();
    */
    return new Subject<string>().asObservable();
  }

  /**
   * Initialize all handler events for Ingenico
   * @returns void
   */
  private initIngenicoEvents(): void {
    this.onComputerName();
  }

  /**
   * Assign onComputerName Handler
   * @returns void
   */
  private onComputerName(): void {
    /*
    this.ingenico.onComputerNameHandler = (computerName: string) => {
      this.logData({request: null, response: {method: 'onComputerNameHandler', data: {computerName: computerName}}});
      this.computerName.next(computerName);
    };
    */
  }

  /**
   * Used to get EMV status
   */
  private isEmvEnabled(): Observable<boolean> {
    const subject = new Subject<boolean>();
    /*
    this.logData({request: null, response: {method: 'retrieveEmvStatus'}});
    this.ingenico.retrieveEmvStatus();
    this.ingenico.isDeviceEmvEnabled = (isEmvEnabled: boolean) => {
      this.logData({request: null, response: {method: 'isDeviceEmvEnabled', data: {isEmvEnabled: isEmvEnabled}}});
      subject.next(isEmvEnabled);
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  /**
   * Used to get HAS version
   */
  private getHasVersion(): Observable<string> {
    const subject = new Subject<string>();
    /*
    this.logData({request: null, response: {method: 'getHASVersion'}});
    this.ingenico.getHASVersion();
    this.ingenico.onHASVersionHandler = (version: string) => {
      this.logData({request: null, response: {method: 'onHASVersionHandler', data: {version: version}}});
      subject.next(version);
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  /**
   * Used to get device version
   */
  private getDeviceVersion(): Observable<string> {
    const subject = new Subject<string>();
    /*
    this.logData({request: INGENICO_CONSTANT.VERSION, response: {method: 'getDeviceVersion'}});
    this.ingenico.getDeviceVersion(INGENICO_CONSTANT.VERSION);
    this.ingenico.getDeviceVersionHandler = (version: DeviceVersion) => {
      this.logData({request: null, response: {method: 'getDeviceVersionHandler', data: {version: version}}});
      subject.next(version.eftp);
      subject.complete();
    };
    */
    return subject.asObservable();
  }

  private logData(data: object): void {
    //this.logger.debug('IngenicoService', 'abcd', JSON.stringify(data) );
  }
}
